import Icon from "@ant-design/icons";
import {Image} from "antd";
import {
    AIGIconImg
} from "../../../../assets";


export const MyIcon = (props) => <Image src={AIGIconImg} preview={false}/>
